var m = require('mithril');
var prop = require('mithril/stream');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var buttonElement = require('../components/button');
var dragscroll = require('../libs/dragscroll');
var modal = require('../layout/components/modal');
var key = require('../libs/keybindings');
var flash = require('../components/flash');
var loaders = require('../layout/components/loaders');
var rowActionDropdown = require('../components/rowActionDropdown');

var state = {
  units: [],
  unitsToShow: [],
  newNode: prop(false),
  loading: false,
  saving: false,
  message: prop([]),
  error: prop([]),
  form: {
    name: '',
    aliases: '',
    scalar: '',
    numerator: '',
    denominator: '',
    kind: '',
    originalName: '',
    numeratorUnits: [],
    denominatorUnits: [],
  },
};

function resetAlerts() {
  state.message([]);
  state.error([]);
}

function parseList(value) {
  return (value || '')
    .split(',')
    .map(function (v) { return v.trim(); })
    .filter(function (v) { return v.length > 0; });
}

function toNumber(value) {
  var n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function resetForm() {
  state.form.name = '';
  state.form.originalName = '';
  state.form.aliases = '';
  state.form.scalar = '';
  state.form.numerator = '';
  state.form.denominator = '';
  state.form.kind = '';
  state.form.numeratorUnits = [];
  state.form.denominatorUnits = [];
}

function cancelEdit() {
  resetAlerts();
  resetForm();
}

function loadUnits(options) {
  options = options || {};
  if (!options.preserveAlerts) {
    resetAlerts();
  }
  state.loading = true;
  return loaders.requestWithLoader({
    loader: 'main',
    method: 'GET',
    url: '/api/v1/unit',
  })
    .then(function (res) {
      state.units = (Array.isArray(res) ? res : []).map(function (u) {
        var aliasText = Array.isArray(u.aliases) ? u.aliases.join(', ') : (u.aliases || '');
        return Object.assign({}, u, { aliasText: aliasText });
      });
      state.newNode(true);
    })
    .catch(function (err) {
      const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to load units');
      state.message([]);
      state.error([msg]);
    })
    .finally(function () {
      state.loading = false;
    });
}

function saveUnit() {
  resetAlerts();
  state.saving = true;

  var payload = {
    name: state.form.name,
    originalName: state.form.originalName,
    aliases: parseList(state.form.aliases),
    scalar: toNumber(state.form.scalar),
    numerator: parseList(state.form.numerator),
    numeratorUnits: parseList(state.form.numerator),
    denominator: parseList(state.form.denominator),
    denominatorUnits: parseList(state.form.denominator),
    kind: state.form.kind || null,
  };

  return loaders.requestWithLoader({
    loader: 'submit',
    method: 'POST',
    url: '/api/v1/unit',
    body: payload,
  })
    .then(function () {
      state.message(['Saved ' + payload.name]);
      resetForm();
      return loadUnits({ preserveAlerts: true });
    })
    .catch(function (err) {
      const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to save unit');
      state.error([msg]);
    })
    .finally(function () {
      state.saving = false;
    });
}

function deleteUnit(name) {
  resetAlerts();

  var confirmDelete = function () {
    return loaders.requestWithLoader({
      loader: 'submit',
      method: 'DELETE',
      url: '/api/v1/unit/' + encodeURIComponent(name),
    })
      .then(function () {
        state.message(['Deleted ' + name]);
        return loadUnits({ preserveAlerts: true });
      })
      .catch(function (err) {
        const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to delete unit');
        state.error([msg]);
      })
      .finally(function () {
        key.unbind('enter');
        modal.vm.close();
      });
  };

  key.unbind('enter');
  key.setScope('modal');
  key('enter', 'modal', confirmDelete);
  modal.vm.title('Delete ' + name + '?');
  modal.vm.body = function () {
    return m('div', [
      m('p', 'Are you sure you want to delete this unit?')
    ]);
  };
  modal.vm.buttons([
    {
      label: "Cancel",
      class: "dib mr2 ",
      func: function () {
        key.unbind('enter');
        modal.vm.close();
      }
    },
    {
      label: "Delete",
      class: "dib red ",
      func: confirmDelete
    }
  ]);
  modal.vm.open();
}

function populateForm(unit) {
  state.form.name = unit.name || '';
  state.form.originalName = unit.name || '';
  state.form.aliases = Array.isArray(unit.aliases) ? unit.aliases.join(', ') : '';
  state.form.scalar = unit.scalar != null ? unit.scalar : '';
  var numerator = unit.numeratorUnits || unit.numerator;
  var denominator = unit.denominatorUnits || unit.denominator;
  state.form.numeratorUnits = Array.isArray(numerator) ? numerator : [];
  state.form.denominatorUnits = Array.isArray(denominator) ? denominator : [];
  state.form.numerator = Array.isArray(numerator) ? numerator.join(', ') : '';
  state.form.denominator = Array.isArray(denominator) ? denominator.join(', ') : '';
  state.form.kind = unit.kind || '';
}

var unitSettings = {
  oninit: loadUnits,
  view: function () {
    return m('div', [
      m('div.flex.flex-wrap', [
        m('div.w-100.mb3', [
          m('p.f6.gray.mt0.mb2', 'Built-in units are read-only. Custom units can be edited or deleted from the Actions menu.'),
          m(paginationWithSearch, {
            data: state.units,
            newNode: state.newNode,
            dataToShow: state.unitsToShow,
            placeHolder: 'Search unit',
            itemsPerPage: 10,
            fieldsToSearch: ['name', 'aliasText', 'kind', 'numeratorUnits', 'denominatorUnits'],
          }, [
            m('div.overflow-hidden',[
              m('div.dragscroll-container', [
                m('div.dragscroll', { oncreate: dragscroll }, [
                  m('table.f4.mb3.mt1.w-100.mr4', { style: { tableLayout: 'fixed'} }, [
                    m('colgroup', [
                      m('col', { style: { width: '7rem' } }),
                      m('col', { style: { width: '10rem' } }),
                      m('col', { style: { width: '9rem' } }),
                      m('col', { style: { width: '13rem' } }),
                      m('col', { style: { width: '13rem' } }),
                      m('col', { style: { width: '7rem' } }),
                      m('col', { style: { width: '7rem' } }),
                    ]),
                    m('thead', [
                      m('tr', [
                        m('th.ph0.tl', 'Name'),
                        m('th.ph0.tl', 'Aliases'),
                        m('th.ph0.tl', 'Scalar'),
                        m('th.ph0.tl', 'Numerator Units'),
                        m('th.ph0.tl', 'Denominator Units'),
                        m('th.ph0.tl', 'Kind'),
                        m('th.ph0.tl', 'Actions'),
                      ])
                    ]),
                    m('tbody',
                      state.unitsToShow.map(function (u) {
                        if (!u || !u.name) {
                          return m('tr', [
                            m('td.tl.pv2', { colspan: 7 }, [
                              m('span', { style: { visibility: 'hidden' } }, 'empty')
                            ])
                          ]);
                        }
                        return m('tr', [
                          m('td.tl.pv2', u.name),
                          m('td.tl.pv2', u.aliasText || ''),
                          m('td.tl.pv2.truncate', u.scalar),
                          m('td.tl.pv2', Array.isArray(u.numeratorUnits) ? u.numeratorUnits.join(', ') : ''),
                          m('td.tl.pv2', Array.isArray(u.denominatorUnits) ? u.denominatorUnits.join(', ') : ''),
                          m('td.tl.pv2', u.kind || ''),
                          m('td.tc.pv2', [
                            u.custom
                              ? m(rowActionDropdown, {
                                items: [
                                  {
                                    label: 'Edit',
                                    icon: 'ion-ios-compose',
                                    onclick: function () { populateForm(u); }
                                  },
                                  {
                                    label: 'Delete',
                                    icon: 'ion-android-delete',
                                    class: 'red',
                                    onclick: function () { deleteUnit(u.name); }
                                  }
                                ]
                              })
                              : m('span.f6.gray.nowrap', {
                                title: 'Built-in units cannot be edited or deleted.'
                              }, [
                                m('i.ion-locked.mr1'),
                                'Read only'
                              ])
                          ]),
                        ]);
                      })
                    )
                  ])
                ])
              ])
            ])
          ])
        ]),
        m('div.w-100', [
          m('h3.mt0', state.form.originalName ? ('Edit Unit: ' + state.form.originalName) : 'Create New Unit'),
          state.error() && state.error().length ? m(flash, { items: state.error(), bg: 'bg-red' }) : null,
          state.message() && state.message().length ? m(flash, { items: state.message(), bg: 'bg-green' }) : null,
          m('div.mr1.w-100.mb2', [
            m('label.db', 'Name'),
            m('input.form-control', {
              value: state.form.name,
              oninput: function (e) { state.form.name = e.target.value; },
              autocomplete: 'off',
            }),
          ]),

          m('div.mr1.w-100.mb2', [
            m('label.db', 'Aliases (comma separated)'),
            m('input.form-control', {
              value: state.form.aliases,
              oninput: function (e) { state.form.aliases = e.target.value; },
              autocomplete: 'off',
            }),
          ]),

          m('div.mr1.w-100.mb2', [
            m('label.db', 'Scalar'),
            m('input.form-control', {
              value: state.form.scalar,
              oninput: function (e) { state.form.scalar = e.target.value; },
              type: 'number',
              step: 'any',
            }),
          ]),

          m('div.mr1.w-100.mb2', [
            m('label.db', 'Numerator units (comma separated)'),
            m('input.form-control', {
              value: state.form.numerator,
              oninput: function (e) { state.form.numerator = e.target.value; },
              autocomplete: 'off',
            }),
          ]),

          m('div.mr1.w-100.mb2', [
            m('label.db', 'Denominator units (comma separated)'),
            m('input.form-control', {
              value: state.form.denominator,
              oninput: function (e) { state.form.denominator = e.target.value; },
              autocomplete: 'off',
            }),
          ]),

          m('div.mr1.w-100.mb2', [
            m('label.db', 'Kind (optional)'),
            m('input.form-control', {
              value: state.form.kind,
              oninput: function (e) { state.form.kind = e.target.value; },
              autocomplete: 'off',
            }),
          ]),
          
          m('div.flex.items-center.justify-end.w-100', [
            state.form.originalName ? m(buttonElement, {
              label: 'Cancel Edit',
              class: 'mr2',
              func: cancelEdit
            }) : null,
            m(buttonElement, {
              label: state.saving ? 'Saving…' : 'Save',
              class: 'green',
              style: { minWidth: '33%' },
              func: saveUnit
            })
          ])
        ]),
      ]),
    ]);
  }
};

module.exports = unitSettings;
